<template>
  <div
    v-if="state != null && state < 3 && show && showAlarms"
    :class="['alarm-border', clicked ? 'has-click' : '']"
    :style="{ borderColor: colors[state] + '88', height: height }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <AlarmIcon
      class="ma-0"
      v-if="showIcon"
      :props="{ size: clicked && hover ? '20px' : '17px' }"
      :state="state"
    />
  </div>
</template>

<script>
import AlarmIcon from "@/components/Icons/AlarmIcon.vue";
import { validateObject } from "@/models/Utils";
import { mapGetters } from "vuex";
import { getAlarmsHistorical } from "@/models/AlarmHistorical";

export default {
  components: {
    AlarmIcon,
  },
  props: {
    height: { type: String, default: "35px" },
    status: { type: Number, default: null },
    showIcon: { type: Boolean, default: false },
    show: { type: Boolean, default: true },
    clicked: { type: Boolean, default: false },
    item: Object,
  },
  data() {
    return {
      colors: [],
      icons: ["warning", "error", "report"],
      state: 4, // No alarms activated.
      hover: false,
    };
  },
  mounted() {
    this.genereteColors();
    this.setState();
    this.populateApi();
  },
  watch: {
    status() {
      this.setState();
    },
    alarmsReceived() {
      this.setState();
    },
  },
  computed: {
    ...mapGetters(["alarmsReceived","showAlarms"]),
  },
  methods: {
    genereteColors() {
      this.colors = [
        this.$vuetify.theme.themes.light.error,
        this.$vuetify.theme.themes.light.warning,
        this.$vuetify.theme.themes.light.accent,
      ];
    },
    async setState() {
      try {
        if (this.status !== null) {
          this.state = this.status;
          return;
        }
        if (!validateObject(this.item, "name")) {
          this.state = 4;
          return;
        }
        let isPlant = !validateObject(this.item, "plant");
        let params;
        if (isPlant) {
          let { id } = this.item;
          params = { id: [id], plantId: false };
        } else {
          let { id, plant } = this.item;
          params = { id: [id], plantId: plant };
        }

        const priority = ["low", "medium", "high"];
        const priorityState = [2, 1, 0];
        const quantity = await this.$store.dispatch("getTotal", params);
        priority.forEach((element, index) => {
          if (quantity[element] != 0) this.state = priorityState[index];
        });
        if (this.state != 4) this.$emit("hasAlarm", this.state);
      } catch (error) {
        console.error(error);
      }
    },
    async populateApi() {
      //only while has no backend
      if (this.item) {
        let { id, name, plant } = this.item;
        if (id % 2 == 0)
          await getAlarmsHistorical({
            name,
            id,
            plant,
          });
      }
    },
  },
};
</script>

<style scoped>
.alarm-border {
  display: flex;
  align-items: flex-start;
  border-left: 3px solid;
  border-radius: 0px !important;
  width: 20px;
}
.has-click {
  cursor: pointer;
}
.has-click:hover {
  border-left: 4px solid;
}
</style>